import { Check, CircleDashed } from "lucide-react";

const itemsFor = (profile, visibleCount) => [
  { key: "photo", label: "Profile photo", done: Boolean(profile.profile_photo_url) },
  { key: "logo", label: "Company logo", done: Boolean(profile.company_logo_url) },
  { key: "phone", label: "Phone", done: Boolean(profile.phone) },
  { key: "website", label: "Website", done: Boolean(profile.website) },
  { key: "bio", label: "Bio", done: Boolean(profile.bio) },
  { key: "links", label: "A visible link", done: visibleCount > 0 },
];

export function CompletionPanel({ profile, links }) {
  const visibleCount = links.links.filter((l) => l.is_visible).length;
  const items = itemsFor(profile, visibleCount);
  const done = items.filter((i) => i.done).length;
  return (
    <aside data-testid="completion-panel" className="h-fit rounded-lg border border-border bg-card p-6">
      <p className="mw-eyebrow">Completion</p>
      <p className="mt-3 text-sm text-foreground/85">
        Required details complete. <span data-testid="completion-count" className="font-semibold">{done} of {items.length}</span> optional details added.
      </p>
      <div className="mt-4 h-1 overflow-hidden rounded-full bg-muted">
        <div className="h-full bg-gold transition-[width] duration-500" style={{ width: `${(done / items.length) * 100}%` }} />
      </div>
      <ul className="mt-5 space-y-3">
        {items.map((i) => (
          <li key={i.key} data-testid={`completion-item-${i.key}`} data-done={i.done} className={`flex items-center gap-3 text-sm ${i.done ? "text-foreground" : "text-muted-foreground"}`}>
            {i.done ? <Check className="h-4 w-4 text-emerald-700" /> : <CircleDashed className="h-4 w-4" />}
            {i.label}
          </li>
        ))}
      </ul>
      <div className="mt-6 flex items-baseline justify-between border-t border-border pt-5">
        <span className="mw-eyebrow">Active links</span>
        <span data-testid="active-links-count" className="font-serif text-3xl">{links.status === "ready" ? visibleCount : "—"}</span>
      </div>
    </aside>
  );
}
